import React from 'react';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import GlobalTooltip from 'components/GlobalTooltip';

function CreateCourtEvent(props) {
  const { rowData } = props;
  const { handleShowCreateEvent } = useFileManagerContext();

  const handleCourtEvent = (rowData) => {
    const data = {
      file_path: rowData?.file_path,
      file_name: rowData?.file_name,
      sk: rowData?.sk,
    };
    handleShowCreateEvent(rowData, data);
  };

  return (
    <>
      <span role="button">
        <GlobalTooltip tooltip="Create Event" className="text-primary-main d-flex align-items-center me-1">
          <span className="bi bi-calendar4-week me-3 F-size12" onClick={() => handleCourtEvent(rowData)} aria-hidden="true" />
        </GlobalTooltip>
      </span>
    </>
  );
}

export default CreateCourtEvent;
